import request from './request';

// 事故车到店跟进列表
export function getAccidentFollow(params) {
    return request('/accident-remind/list', {
        method: 'POST',
        params,
    });
}
// 查询车辆碰撞线索
export function getAccidentClues(params) {
    return request(`/accident-remind/${params.id}`, {
        method: 'GET',
    });
}
// 确认到店
export function confirmArrived(params) {
    return request('/accident-remind/arrived', {
        method: 'PATCH',
        params,
    });
}
// 未到店
export function confirmNotBack(params) {
    return request(`/accident-remind/${params.id}/not-back`, {
        method: 'PATCH',
        params,
    });
}
